module.exports = __webpack_public_path__ + "static/media/leagueDefaultBackground.2422152e.jpg";